export default __webpack_public_path__ + "static/media/RightOneButton.f99ea03c.webp";